import { jsxs, jsx } from 'react/jsx-runtime';
import { SVG } from './utils/style.svg.js';
import { getDefaultHeight } from './utils/get-default-height.js';

const FlipIcon = ({
  color = "currentColor",
  ...svgProps
}) => {
  return /*#__PURE__*/jsxs(SVG, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 21",
    height: getDefaultHeight(svgProps, 21),
    ...svgProps,
    fill: "none",
    stroke: color,
    strokeWidth: "1.5",
    strokeMiterlimit: "10",
    children: [/*#__PURE__*/jsx("path", {
      d: "M9.22985 16.6369L5.36587 18.0821C5.05877 18.1993 4.80005 17.7219 4.80005 17.0231V2.37965C4.80005 1.68089 5.05877 1.20348 5.36587 1.31632L9.22985 2.76157C9.43598 2.8397 9.60005 3.35183 9.60005 3.90736V15.4954C9.60005 16.0509 9.43598 16.5631 9.22985 16.6412V16.6369Z"
    }), /*#__PURE__*/jsx("path", {
      d: "M14.8001 6.5C18.0001 6.5 19.2001 8.04166 19.2001 8.73548C19.2001 10.3754 15.0799 11.7 10.0001 11.7C4.92024 11.7 0.800049 10.3754 0.800049 8.73548",
      strokeLinecap: "round"
    }), /*#__PURE__*/jsx("path", {
      d: "M15.7555 9.05579L13.437 6.7373L15.7555 4.41882",
      strokeLinecap: "round"
    })]
  });
};

// <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
// <g clip-path="url(#clip0_580_197)">
// <path d="M9.22985 16.6369L5.36587 18.0821C5.05877 18.1993 4.80005 17.7219
// 4.80005 17.0231V2.37965C4.80005 1.68089 5.05877 1.20348 5.36587
// 1.31632L9.22985 2.76157C9.43598 2.8397 9.60005 3.35183 9.60005
// 3.90736V15.4954C9.60005 16.0509 9.43598 16.5631 9.22985 16.6412V16.6369Z"
// stroke="#272525" stroke-width="1.5" stroke-miterlimit="10"/> <path
// d="M14.8001 6.5C18.0001 6.5 19.2001 8.04166 19.2001 8.73548C19.2001 10.3754
// 15.0799 11.7 10.0001 11.7C4.92024 11.7 0.800049 10.3754 0.800049 8.73548"
// stroke="#272525" stroke-width="1.5" stroke-miterlimit="10"
// stroke-linecap="round"/> <path d="M15.7555 9.05579L13.437 6.7373L15.7555
// 4.41882" stroke="#272525" stroke-width="1.5" stroke-miterlimit="10"
// stroke-linecap="round"/> </g> <defs> <clipPath id="clip0_580_197"> <rect
// width="20" height="20" fill="white" transform="translate(0 0.5)"/>
// </clipPath> </defs> </svg>

export { FlipIcon };
//# sourceMappingURL=flip.js.map
